/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-23 16:06:51
 * @LastEditTime: 2020-04-03 12:16:22
 * @LastEditors: DOJO
 */
import axios from 'axios'
import { Toast } from '@yunji/h5'
import YunJi from '@/common/js/YunJi'


const AJAX = axios.create({
  // baseURL: '//' + window.globalConfig.linkPath +'/yunjispecialbuyer',
  withCredentials: true
})
const hostname = window.location.hostname
const y = hostname.split('.')[0]
if (y == 't-do-dev' || y == 'txst') { // 现网环境 
  window.globalConfig.xinyunPath = 't-do-dev.yunjiglobal.com'
} else {
  window.globalConfig.xinyunPath = 'xinyun.yunjiglobal.com'
}
// AJAX.interceptors.response.use(res => {
//   if (res.data.errorCode == 2418) {
//     let returnUrl = window.location.href
//     let jumpUrl = '//' + window.globalConfig.linkPath + '/yunjispecialbuyer/skygroup/getVueUser.xhtml?returnUrl=' + encodeURIComponent(returnUrl+'&authorize=true')
//     window.location.href = "//"+window.globalConfig.yunjibuyerPath+"/basecomponents/v1000/weChatAuthorized_2.html?returnUrl="+encodeURIComponent(jumpUrl) + "&titleName=云集"
//     return
//   }
//   if (res.data.errorCode == 1009 ) {
//     location.href = "yunji://shop/shopDetail/shopping?appCont=2"
//     return
//   }

//   return res.data
// }, err => {
//   // Toast('网络错误')
// })
const Http = (function () {
  const instance = axios.create({
    // baseURL: '//' + window.globalConfig.itemBasePath + '/yunjiitemapp/app/attempt',
    withCredentials: true
  })
  instance.interceptors.response.use((res) => {
    if (res.data.errorCode == 2418) {
      const returnUrl = window.location.href
      const jumpUrl = `//${window.globalConfig.linkPath}/yunjispecialbuyer/skygroup/getVueUser.xhtml?returnUrl=${encodeURIComponent(`${returnUrl}&authorize=true`)}`
      window.location.href = `//${window.globalConfig.yunjibuyerPath}/basecomponents/v1000/weChatAuthorized_2.html?returnUrl=${encodeURIComponent(jumpUrl)}&titleName=云集`
      return
    }
    if (res.data.errorCode == 1009) {
      location.href = 'yunji://shop/shopDetail/shopping?appCont=2'
      return
    }
    return res.data
  }, error => Promise.reject(error))
  return instance
}())


// 获取token
export const getToken = params => Http.get(`//${window.globalConfig.xinyunPath}/yunjixinyun/getUpToken.json`, { params })

// 上传图片
export const updataFile = (params, config) => Http.post('https://up.qbox.me', params, config)

/**
 * 提交爆品
 * 
 * */ 
export const insertHotPut = params => Http.post(`//${window.globalConfig.itemBasePath}/yunjiitemapp/app/pandora/insertHotPut.json`, params)


/**
 * 提交爆品
 * 
 * */ 
export const insertHotPutGet = params => Http.get(`//${window.globalConfig.itemBasePath}/yunjiitemapp/app/pandora/insertHotPut.json`, { params })
